const namedEntities: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

const MAX_CODE_POINT = 0x10ffff;

// `String.fromCodePoint` THROWS on anything above U+10FFFF, and this runs on provider text
// during form seeding — one malformed entity in someone's calendar description would take
// the whole popup down. An entity we cannot decode stays literal, which is also what the
// named-entity branch does for a name it does not know.
const fromCodePoint = (code: number, match: string) => {
  if (!Number.isInteger(code) || code < 0 || code > MAX_CODE_POINT) {
    return match;
  }
  return String.fromCodePoint(code);
};

// A single pass, so `&amp;lt;` decodes to the literal text `&lt;` instead of being
// decoded twice into `<`.
export const decodeHtmlEntities = (value: string): string =>
  value
    .replace(/&#(\d+);/g, (match, code) => fromCodePoint(Number(code), match))
    .replace(/&#x([0-9a-f]+);/gi, (match, code) =>
      fromCodePoint(parseInt(code, 16), match),
    )
    .replace(
      /&(amp|lt|gt|quot|apos|nbsp);/gi,
      (match, name) => namedEntities[name.toLowerCase()] ?? match,
    );

export const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
